import { withRouter } from 'react-router-dom';

import EVoucherCancelPayment from './EVoucherCancelPayment';

export default withRouter(EVoucherCancelPayment);
